import { render, staticRenderFns } from "./ShortcutBtn.vue?vue&type=template&id=4082d524&scoped=true"
import script from "./ShortcutBtn.vue?vue&type=script&lang=js"
export * from "./ShortcutBtn.vue?vue&type=script&lang=js"
import style0 from "./ShortcutBtn.vue?vue&type=style&index=0&id=4082d524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082d524",
  null
  
)

export default component.exports